const allgeneralrec = { data: [], loading: true, cache: {} };
export const GetAllGeneralRec = (state = allgeneralrec, action) => {
  switch (action.type) {
    case "get_allgeneralrec":
      return {
        ...state,
        data: action?.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "clear_generalrec_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};
